import { ShippoApi } from '../util/api';
import { StatusCode } from '../util/enums';
import { storableError } from '../util/errors';
import { showErrorToast, showSuccessToast } from '../util/toast';
import { fetchCurrentUser } from './user.duck';

// ================ Action types ================ //

export const ShippoActionTypes = Object.freeze({
  CREATE_ADDRESS_REQUEST: 'app/shippo/CREATE_SHIPPO_ADDRESS_REQUEST',
  CREATE_ADDRESS_SUCCESS: 'app/shippo/CREATE_SHIPPO_ADDRESS_SUCCESS',
  CREATE_ADDRESS_ERROR: 'app/shippo/CREATE_SHIPPO_ADDRESS_ERROR',

  FETCH_CARRIER_REQUEST: 'app/shippo/FETCH_CARRIER_REQUEST',
  FETCH_CARRIER_SUCCESS: 'app/shippo/FETCH_CARRIER_SUCCESS',
  FETCH_CARRIER_ERROR: 'app/shippo/FETCH_CARRIER_ERROR',
});

// ================ Reducer ================ //

const initialState = {
  saveShippoAddressInProgress: false,
  shippoAddressSaved: false,
  saveShippoAddressError: null,
  clearForm: false,
  saveWeightInProgress: false,
  fetchListingsInProgress: false,
  listingsFetched: false,
  allListings: [],
  fetchCarriersInProgress: false,
  carriersData: {},
  carriersError: null,
  isInternational: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ShippoActionTypes.CREATE_ADDRESS_REQUEST:
      return { ...state, saveShippoAddressInProgress: true };

    case ShippoActionTypes.CREATE_ADDRESS_SUCCESS:
      return { ...state, saveShippoAddressInProgress: false, shippoAddressSaved: true };

    case ShippoActionTypes.CREATE_ADDRESS_ERROR:
      return { ...state, saveShippoAddressInProgress: false, saveShippoAddressError: true };

    case ShippoActionTypes.FETCH_CARRIER_REQUEST:
      return { ...state, fetchCarriersInProgress: true };

    case ShippoActionTypes.FETCH_CARRIER_SUCCESS:
      return { ...state, fetchCarriersInProgress: false, carriersData: payload };

    case ShippoActionTypes.FETCH_CARRIER_ERROR:
      return { ...state, fetchCarriersInProgress: false, carriersError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const createShippoAddressRequest = () => ({
  type: ShippoActionTypes.CREATE_ADDRESS_REQUEST,
});
export const createShippoAddressSuccess = () => ({
  type: ShippoActionTypes.CREATE_ADDRESS_SUCCESS,
});
export const createShippoAddressError = () => ({ type: ShippoActionTypes.CREATE_ADDRESS_ERROR });

export const fetchCarriersRequest = () => ({ type: ShippoActionTypes.FETCH_CARRIER_REQUEST });
export const fetchCarriersSuccess = data => ({
  type: ShippoActionTypes.FETCH_CARRIER_SUCCESS,
  payload: data,
});
export const fetchCarriersError = error => ({
  type: ShippoActionTypes.FETCH_CARRIER_ERROR,
  payload: error,
});

// ================ Selectors ================ //

export const selectShippoAddressStatus = state => {
  const { saveShippoAddressInProgress, saveShippoAddressError, shippoAddressSaved } = state.shippo;
  return {
    saveShippoAddressInProgress,
    saveShippoAddressError,
    shippoAddressSaved,
  };
};
export const fetchShippingCarriersSelector = state => {
  const { carriersData, fetchCarriersError, fetchCarriersInProgress } = state.shippo;
  return {
    carriersData,
    fetchCarriersError,
    fetchCarriersInProgress,
  };
};
// =

// ================ Thunks ================ //

export const createShippoAddress = params => async (dispatch, getState, sdk) => {
  if (!Object.keys(params).length) return;

  dispatch(createShippoAddressRequest());

  try {
    const response = await ShippoApi.createAddress(params);
    if (response.statusCode === StatusCode.SUCCESS) {
      dispatch(fetchCurrentUser());
      dispatch(createShippoAddressSuccess());
      showSuccessToast('Shipping address saved!');
      return response;
    } else {
      dispatch(createShippoAddressError());
    }
  } catch (error) {
    dispatch(createShippoAddressError());

    showErrorToast('Failed to save shipping address. \n' + error );
  }
};

export const fetchShippingCarriers = params => async (dispatch, getState, sdk) => {
  dispatch(fetchCarriersRequest());

  try {
    const response = await ShippoApi.getCarriers(params);
    if (response.statusCode === StatusCode.SUCCESS) {
      const { data } = response;
      dispatch(fetchCarriersSuccess(data));
    } else {
      dispatch(fetchCarriersError(new Error('Failed to fetch carriers')));
    }
    return response;
  } catch (error) {
    dispatch(fetchCarriersError(storableError(error)));
  }
};

export const loadData = () => fetchCurrentUser();
